import { ViewPage } from './ViewPage';
import React, { useState, useEffect, useRef } from "react";
import { Box, Button, Container, Card, CardContent } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Fab } from '@mui/material';
import { useReactToPrint } from 'react-to-print';
import { PrintIcon } from '../../../common/icons';
import { stakeholderType } from '../../../common/spinLoader';

function ViewPageWraper(props) {
    const componentRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();
    const urn = location?.state?.urn;
    // const page = location?.state?.page;
    // const [viewpage, setViewpage] = useState(location.state?.page ? location.state?.page : 1);
    // console.log("page", location?.state?.tabValue);
    const status = location?.state?.status;
    const tabValue = location?.state?.tabValue;
    const print = useReactToPrint({
        content: () => componentRef.current,
    })
    console.log("state", location?.state)
    const goBack = () => {
        if (location.state?.pageName === "invoicePayment") {
            navigate('../invoicePayment', { state: { status: status, tabValue: tabValue, page: location.state.page, stakeholderType: location?.state?.stakeholderType } });
        }
        else if (location.state?.pageName === "paymentStatus") {
            navigate('../PaymentStatusABRPLUser', { state: { status: status, selectedTab: location?.state?.selectedTab, pageName: location?.state?.pageName, stakeholderTab: location?.state?.stakeholderTab, paymentTypeFilter: location?.state?.paymentTypeFilter } });
        }
        else if (location?.state?.goBack == true) {
            navigate(-1);
        }
        else {
            navigate('../shortlisting', { state: { status: status, tabValue: tabValue, page: location.state.page } });
        }
    }
    return (
        <Container maxWidth="xxl">
                    <Typography variant="h4" sx={{ mb: 2 }}>
                        <Fab size="small" aria-label="back" title='Back' onClick={() => goBack()}>
                            <KeyboardArrowLeftRounded />
                        </Fab>
                    </Typography>
                        <Card >
                            <CardContent>
                                <ViewPage urn={urn} ref={componentRef} isPreview="true" bambooSpeciesRes={props.bambooSpeciesRes}></ViewPage>
                            </CardContent>
                        </Card>
                        <Box hidden={tabValue === "1"} display='flex' alignItems="center" mt={2} justifyContent="center" style={{ float: "right" }} >
                            <Button startIcon={<PrintIcon/>} sx={{ minWidth: 100 }} variant='contained' onClick={print}>Print</Button>
                        </Box>
        </Container>
    );
}
export default ViewPageWraper;